import { RemoveYear, hasInErrorReason } from "./helpers.js";
class LifeClaimSearchImpl {
    constructor() {
        this.format = (response) => {
            const searchResultMetadataRaw = response?.searchResultMetadata ?? {};
            const { startIndex, totalResults, itemsPerPage, } = searchResultMetadataRaw;
            const rawClaims = response?.claims ?? [];
            const claims = rawClaims;
            const searchResultMetadata = {
                startIndex,
                totalResults,
                itemsPerPage,
            };
            const claimsSearch = claims.flatMap((claim) => {
                if (hasInErrorReason(claim.claimProcessingStage, claim.customClaimStatusReason, claim.claimStatusReason, claim.claimStatusReasonDesc, claim.claimStatusReasonCdDesc, claim.customClaimStatusReasonCdDesc)) {
                    return [];
                }
                const { claimId, aliasClaimId, claimSystemCd, customClaimStatusReason, claimStatusEffectiveDt, claimApprovedThruDt, claimBenefitBeginDt, claimBenefitEndDt, benefitResumeDate, claimPaidThroughDate, claimClosedDt, claimMaxDurationDt, claimReceivedTs, takeoverClaimInd, claimDecisionDt, employeeContributionPostTaxPct, payGroupNbr, claimCoverageTypeCd, duration, supplementalCoverageAmt, causeOfDeath, baseCoverageAmt, totalCoverageAmt, claimWaiverApprovalDt, dateOfDeath, claimOwner = {}, derivedClaimStatusDesc, claimSubmissionSource, } = claim;
                const { recentPaymentDetails = {}, socialSecurityOffsetAmt, paymentAmt, monthsPaid, totalPaidToDtAmt, totalDaysPaidCount, claimDaysPaidCount, claimSocialSecurityAwardDt, workIncentiveBenefitInd, firstPaymentDt, totalHealthCareCreditAmt, paidDuration, socialSecurityOffsetInd, workersCompensationOffsetInd, pendingCoverageDetails = [], } = claim.claimPaymentsSummaryDetails || {};
                const insuredDetails = claim.insuredDetails || {};
                const claimantDetails = claim.claimantDetails || {};
                const hasInsuredDetails = insuredDetails && Object.keys(insuredDetails).length > 0;
                const fallbackDetails = hasInsuredDetails ? insuredDetails : claimantDetails;
                const { lastName: insuredLastName, firstName: insuredFirstName, insuredDisplayName, claimantDisplayName: fallbackInsuredDisplayName, genderAtBirth: insuredGender, insuredRelationshipDesc, dateOfBirth: insuredDateOfBirth, postalAddresses: insuredPostalAddresses = [], } = fallbackDetails;
                const { lastName: claimantLastName, firstName: claimantFirstName, claimantDisplayName, genderAtBirth: claimantGender, hireDt, jobTitleName, digitalAddresses, taxIdentificationNumber, employeeId, age: claimantAge, dateOfBirth: claimantDateOfBirth, postalAddresses: claimantPostalAddresses = [], } = claimantDetails;
                const { divisionId, divisionName, monthlyCoveredSalaryAmt, weeklyCoveredSalaryAmt, eligibilityGroup, eligibilityGroupDesc, groupAgreementID, choiceCd, empContributionPremiumAmt, sicCd, incurredDt, eliminationPeriodEndDate, customCoverageDesc, } = claim.coverageDetails || {};
                const { employeeLocationName: ReportingLocation } = claim.employeeInformation || {};
                const { disabilityBeginDt, lagDays, primaryDiagnosisCd, primaryDiagnosisDesc, secondaryDiagnosisCd, secondaryDiagnosisDesc, workLevel, workRelatedInd, actualDeliveryDt, lastWorkedDt, partTimeRtwDt, fullTimeRtwDt, projectedFullTimeRtwDt, projectedPartTimeRtwDt, lostDays, } = claim.disabilityDetails || {};
                const { paymentPeriodEndDt, paymentRecentCheckAmt, paymentGrossBenefitAmt, paymentDeductionsAmt, paymentOffsetsAmt, paymentIssueDt: paymentEndDt, workerCompensationOffsetsAmt, nonPaymentStartDt, nonPaymentEndDt, OtherOffsetsAmt: otherOffsetsAmt, checkNumber, ficaAmt, healthCareCreditAmt, stateOffsetAmt, } = recentPaymentDetails;
                const insuredPrimaryAddress = (hasInsuredDetails ? insuredPostalAddresses : claimantPostalAddresses)?.[0] || {};
                const claimantPrimaryAddress = claimantPostalAddresses?.[0] || {};
                const finalAge = hasInsuredDetails ? (fallbackDetails.age || claimantAge) : claimantAge;
                const pendingCoverages = pendingCoverageDetails.length > 0
                    ? pendingCoverageDetails
                    : [{}];
                const rows = [];
                pendingCoverages.forEach((pendingCoverage) => {
                    rows.push({
                        insuredLastName: insuredLastName,
                        insuredFirstName: insuredFirstName,
                        insuredDisplayName: insuredDisplayName || fallbackInsuredDisplayName,
                        insuredGender,
                        insuredAge: finalAge,
                        insuredRelationshipDesc: insuredRelationshipDesc?.trim() ? insuredRelationshipDesc : 'Self',
                        insuredPostalAddresses,
                        insuredAddressLineOne: insuredPrimaryAddress.addressLineOne,
                        insuredAddressLineTwo: insuredPrimaryAddress.addressLineTwo,
                        insuredAddressLineThree: insuredPrimaryAddress.addressLineThree,
                        insuredCity: insuredPrimaryAddress.city,
                        insuredJurisdictionCode: insuredPrimaryAddress.jurisdictionCode,
                        insuredPostalCode: insuredPrimaryAddress.postalCode || insuredPrimaryAddress.postalCd,
                        insuredAddressTypeCd: insuredPrimaryAddress.addressTypeCd,
                        insuredDateOfBirth: insuredDateOfBirth,
                        dateOfBirth: insuredDateOfBirth,
                        lastName: insuredLastName,
                        firstName: insuredFirstName,
                        fullName: insuredDisplayName || fallbackInsuredDisplayName,
                        age: finalAge,
                        postalCode: insuredPrimaryAddress.postalCode || insuredPrimaryAddress.postalCd,
                        city: insuredPrimaryAddress.city,
                        addressLineOne: insuredPrimaryAddress.addressLineOne,
                        addressLineTwo: insuredPrimaryAddress.addressLineTwo,
                        genderAtBirth: insuredGender,
                        state: insuredPrimaryAddress.jurisdictionCode,
                        claimantLastname: claimantLastName,
                        claimantFirstname: claimantFirstName,
                        claimantDisplayName,
                        claimantGender: claimantGender,
                        claimantPostalAddresses,
                        claimantAddressLineOne: claimantPrimaryAddress.addressLineOne,
                        claimantAddressLineTwo: claimantPrimaryAddress.addressLineTwo,
                        claimantAddressLineThree: claimantPrimaryAddress.addressLineThree,
                        claimantCity: claimantPrimaryAddress.city,
                        claimantJurisdictionCode: claimantPrimaryAddress.jurisdictionCode,
                        climentPostalCode: claimantPrimaryAddress.postalCd,
                        claimantAddressTypeCd: claimantPrimaryAddress.addressTypeCd,
                        claimantDateOfBirth: claimantDateOfBirth,
                        claimentAge: claimantAge,
                        coverageProductType: pendingCoverage.coverageProductType,
                        paymentsBasicInsuredPendingAmt: pendingCoverage.basicInsuredPendingAmt,
                        supplementalInsuredPendingAmt: pendingCoverage.supplementalInsuredPendingAmt,
                        totalInsuredPaidAmt: pendingCoverage.totalInsuredPendingAmt,
                        paymentPeriodEndDt,
                        paymentRecentCheckAmt,
                        paymentGrossBenefitAmt,
                        paymentDeductionsAmt,
                        paymentOffsetsAmt,
                        paymentEndDt,
                        workerCompensationOffsetsAmt,
                        nonPaymentStartDt,
                        nonPaymentEndDt,
                        socialSecurityOffsetAmt,
                        otherOffsetsAmt,
                        monthlyCoveredSalaryAmt,
                        paymentAmt,
                        monthsPaid,
                        checkNumber,
                        ficaAmt,
                        firstPaymentDt,
                        healthCareCreditAmt,
                        totalHealthCareCreditAmt,
                        totalPaidToDtAmt,
                        totalDaysPaidCount,
                        claimDaysPaidCount,
                        socialSecurityOffsetInd,
                        workersCompensationOffsetInd,
                        paidDuration,
                        claimId,
                        legacyClaimNumber: aliasClaimId,
                        claimSystemCd,
                        claimStatus: derivedClaimStatusDesc,
                        claimSubmissionSource: claimSubmissionSource,
                        customClaimStatusReason: customClaimStatusReason,
                        statusEffectiveDt: claimStatusEffectiveDt,
                        claimApprovedThruDt,
                        claimBenefitBeginDt,
                        claimBenefitEndDt,
                        benefitResumeDt: benefitResumeDate,
                        claimPaidThroughDate,
                        claimSocialSecurityAwardDt,
                        claimClosedDt,
                        eliminationPeriodEndDate,
                        workIncentiveBenefitInd,
                        claimMaxDurationDt,
                        receivedDt: claimReceivedTs,
                        supplementalCoverageAmt,
                        hireDt,
                        jobTitle: jobTitleName,
                        jobTitleName,
                        personDisplayName: claimOwner.personDisplayName,
                        personID: claimOwner.personID,
                        digitalAddresses,
                        taxIdentificationNumber,
                        employeeId,
                        divisionId,
                        dateOfDeath,
                        coverageSourceDesc: customCoverageDesc,
                        divisionName,
                        weeklyCoveredSalaryAmt,
                        ReportingLocation,
                        eligibilityGroup,
                        eligibilityGroupDesc,
                        groupAgreementId: groupAgreementID,
                        choiceCd,
                        empContributionPremiumAmt,
                        coverageType: claimCoverageTypeCd,
                        causeOfDeath,
                        totalCoverageAmount: totalCoverageAmt,
                        sicCd,
                        incurredDt,
                        baseCoverageAmount: baseCoverageAmt,
                        claimWaiverApprovalDt,
                        claimsWaiverApprovalDt: claimWaiverApprovalDt,
                        claimStatusReason: customClaimStatusReason,
                        disabilityBeginDt: RemoveYear(disabilityBeginDt),
                        lagDays,
                        primaryDiagnosisCd,
                        primaryDiagnosisDesc,
                        secondaryDiagnosisCd,
                        secondaryDiagnosisDesc,
                        workLevel,
                        workRelatedInd,
                        actualDeliveryDt: RemoveYear(actualDeliveryDt),
                        lastDateWorked: lastWorkedDt,
                        partTimeRTWDt: RemoveYear(partTimeRtwDt),
                        fullTimeRTWDt: fullTimeRtwDt ? (RemoveYear(fullTimeRtwDt)) : null,
                        projectedFullTimeRtwDt,
                        projectedPartTimeRtwDt,
                        lostDays,
                        takeoverClaimInd,
                        claimDecisionDt,
                        employeeContributionPostTaxPct,
                        stateOffsetAmt,
                        duration,
                        payGroupNbr,
                    });
                });
                return rows;
            });
            return { claimsSearch, searchResultMetadata };
        };
    }
}
export const LifeClaimSearch = new LifeClaimSearchImpl();
